import { writable, get } from 'svelte/store'

const agents = writable({})

export default {
    subscribe: agents.subscribe,
    get: () => get(agents),
    set: (dict) => { agents.set(dict) }
  }